import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '400px'
};

const zoom = 15;
let center;

const saveClinicLocation = async (appointmentId, location) => {
    await axios.post(`/confirmation/saveClinicLocation/${appointmentId}`, location);
}

const Map = (props) => {
    const { appointmentId, address, location } = props;
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyDSGnlmIGObHIWSjbe1lqjn4wg3tuEfo5w",
        language: 'iw',
        region: 'IL'
    })

    const [map, setMap] = useState(null)

    const onLoad = useCallback(async function callback(map) {
        if (!location) {
            var position;
            await new window.google.maps.Geocoder().geocode({ 'address': address }, function (results, status) {
                if (status == 'OK') {
                    position = results[0].geometry.location;
                    center = {
                        lat: position.lat(),
                        lng: position.lng(),
                    };
                    new window.google.maps.Marker({
                        map: map,
                        position: position
                    });
                }
            });
            saveClinicLocation(appointmentId, position);
        } else {
            center = {
                lat: location.lat,
                lng: location.lng,
            };
            var latLng = new window.google.maps.LatLng(location.lat, location.lng);
            new window.google.maps.Marker({
                map: map,
                position: latLng
            });
        }

        if (center) {
            var bounds = new window.google.maps.LatLngBounds(center);
            map.fitBounds(bounds);
            window.google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                if (this.getZoom() > zoom) {
                    this.setZoom(zoom);
                }
            });
            setMap(map)
        }
    }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    return isLoaded && (address || location) ? (
        <div className="container d-flex justify-content-center elements-spacing">
            <GoogleMap
                region={"IL"}
                language={"iw"}
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoom}
                onLoad={onLoad}
                onUnmount={onUnmount}
            />
        </div>
    ) : <></>
}

export default Map;